import { type RouteRecordRaw } from 'vue-router'

export const printShopEmbedRouter: RouteRecordRaw[] = [
  {
    component: async () => import('../views/PrintShopEmbedView.vue'),
    meta: {
      title: 'marketing.print-shop',
    },
    name: 'brand.marketing.print-shop',
    path: 'marketing/print-shop',
  },
]
